
export default {
  name: 'InlineBlok',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
